import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const STYLES = {
  royal: "bg-royal text-white hover:bg-lime hover:text-navy",
  navy: "bg-navy text-white hover:bg-lime hover:text-navy",
  lime: "bg-lime text-navy hover:bg-white",
  ghost: "border border-navy/25 text-navy hover:border-navy hover:bg-navy hover:text-white",
  ghostDark: "border border-white/30 text-white hover:border-lime hover:bg-lime hover:text-navy",
};

export const CtaLink = ({ to, children, variant = "royal", className = "", testid, ...rest }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-3 rounded-full py-3.5 pl-6 pr-3 text-[0.95rem] font-semibold transition-[background-color,color,border-color] duration-300 ${STYLES[variant]} ${className}`}
    {...rest}
  >
    <span>{children}</span>
    <span className="grid h-8 w-8 place-items-center overflow-hidden rounded-full bg-current/0">
      <ArrowUpRight
        aria-hidden="true"
        className="h-5 w-5 transition-transform duration-500 ease-expo group-hover:rotate-45"
      />
    </span>
  </Link>
);
